import React from 'react';
import { Image, Icon, Checkbox, Container } from 'semantic-ui-react';
import { Media } from '../../../../mediaSetting.js';
import { NetworkTypes } from '../../../../constants/networkTypes.js';

export default function CenterPanel(props) {
  const getHeaderRowMarkup = () => {
    let disableClass = props.saveIntermediateClick ? ' disableCenterPanel disable' : '';
    const tableHeaderMarkup = (
      <div
        className={
          'filterRowBackGround mrts pdtnull pdbnull header-row inline-flex center-flex space-between max-width ' +
          disableClass
        }
        id="user-role-header"
      >
        {/* Column #1 header */}
        <div className="ui column tablet only icon input color-white hand display-flex my-role-filter mrrs">
          <input
            className="color-white borderless color-primary-dark-hover-lighter-bg max-width pdxs search"
            type="text"
            onChange={props.handleSearchTerm}
            value={props.searchTerm}
            placeholder={APP.LANGUAGE.MyRoles.Filter}
            style={{ lineHeight: '1.4em' }}
          />
          <i className="filter  icon" />
        </div>
        <div className="inline-flex center-flex">
          <Container
            fluid
            as={Media}
            greaterThanOrEqual="computer"
            className={props.searchTerm.trim() != '' ? 'color-placeholder mrrxs' : 'color-white mrrxs'}
          >
            {APP.LANGUAGE.MyRoles.SelectAll}
          </Container>
          <Container
            fluid
            as={Media}
            lessThan="computer"
            className={props.searchTerm.trim() != '' ? 'color-placeholder mrrxs' : 'color-white mrrxs'}
            style={{ width: '17px' }}
          >
            {APP.LANGUAGE.MyRoles.SelectAllOnMobile}
          </Container>
          <Checkbox
            className="my-role-select-all"
            disabled={props.searchTerm.trim() != ''}
            checked={props.ifSelectAll}
            onChange={props.selectAll}
          />
        </div>
      </div>
    );
    return tableHeaderMarkup;
  };

  const rendermyRoleRows = (myRoles, gray) => {
    let iterator = myRoles;
    if (iterator) {
      return iterator.map((myRole, i) => {
        let personNetworkRoleId = myRole.personNetworkRoleId;
        let removedClassName = myRole.isDeleted == true ? ' deleteRow ' : '';

        let iconNetworkType = (
          <Image src={APP.IMAGES.OrgUnitsIcon.default} className="centerAlignNetworkTypeIcon" circular />
        );

        if (myRole.typeId === NetworkTypes.WaitingArea) {
          iconNetworkType = (
            <Image src={APP.IMAGES.WaitingAreaIcon.default} className="centerAlignNetworkTypeIcon" circular />
          );
        } else if (myRole.typeId === NetworkTypes.MeetingRoom) {
          iconNetworkType = (
            <Image src={APP.IMAGES.MeetingRoomIcon.default} className="centerAlignNetworkTypeIcon" circular />
          );
        } else if (myRole.typeId === NetworkTypes.GroupConsultation) {
          iconNetworkType = (
            <Image src={APP.IMAGES.GCWaitingAreaIcon.default} className="centerAlignNetworkTypeIcon" circular />
          );
        }

        return (
          <div
            className={'row flexible row-hoverable border-bottom whiteBackGround' + removedClassName}
            data-opaque={!!gray}
            key={personNetworkRoleId}
            data-show={
              (props.saveIntermediateClick == true && myRole.isDeleted == true) || !props.saveIntermediateClick
            }
          >
            <div className={'ui one wide computer only   left-text column centerAlignNetworkTypeIcon'}>
              {iconNetworkType}
            </div>
            <div className={'ui one wide  tablet mobile only left-text column centerAlignNetworkTypeIcon'}>
              {iconNetworkType}
            </div>

            {/* for computer only */}
            <div className={'ui seven wide computer only  left-text column centerAlignVertical wrap-link '}>
              {myRole.name}
              <br />{' '}
              <div
                className={'mobileSecondRow   text-size-ms ' + removedClassName}
                data-show={myRole.type != 'Organisational Unit'}
              >
                {myRole.organisationAbbreviatedName}
              </div>
            </div>
            <div className={'ui  six wide  computer only  column centerAlignVertical   '}>{myRole.role}</div>

            {/* for tablet and mobile */}
            <div className={'ui thirteen wide tablet mobile only  left-text column centerAlignVertical wrap-link'}>
              {myRole.name + (myRole.type != 'Organisational Unit' ? ` (${myRole.organisationAbbreviatedName})` : '')}
              <br /> <div className={'mobileSecondRow   text-size-ms ' + removedClassName}>{myRole.role}</div>
            </div>

            <div
              className={'ui one wide centerAlignIcons fixedAlignIcons'}
              onClick={() => {
                props.handleDeleteRole(personNetworkRoleId);
              }}
              data-show={!myRole.isDeleted}
            >
              <Icon name="trash" className="removeIcon mrrxxs" />
            </div>
            <div
              className={'ui one wide centerAlignIcons fixedAlignIcons'}
              onClick={() => {
                props.handleUndoDeleteRole(personNetworkRoleId);
              }}
              data-show={!!myRole.isDeleted}
            >
              <Icon name="undo" className="undoIcon mrrxxs" />
            </div>
          </div>
        );
      });
    }
  };

  let myRolesMatchingSearchTermMarkup = '';
  let myRolesNotMatchingSearchTermMarkup = '';

  if (props.myRoles && props.myRoles.length > 0) {
    const sortedmyRolesList = props.myRoles;
    let myRolesMatchingSearchTerm = sortedmyRolesList;
    let myRolesNotMatchingSearchTerm = [];
    const searchTerm = props.searchTerm;
    if (searchTerm && searchTerm.trim().length > 0) {
      // do the filtering
      const searchTermLowerCase = searchTerm.toLowerCase();
      myRolesMatchingSearchTerm = [];
      myRolesNotMatchingSearchTerm = [];

      sortedmyRolesList.forEach((myRole) => {
        if (
          myRole.name.toLowerCase().indexOf(searchTermLowerCase) > -1 ||
          myRole.organisationAbbreviatedName.toLowerCase().indexOf(searchTermLowerCase) > -1 ||
          myRole.role.toLowerCase().indexOf(searchTermLowerCase) > -1
        )
          myRolesMatchingSearchTerm.push(myRole);
        else {
          myRolesNotMatchingSearchTerm.push(myRole);
        }
      });
    }
    myRolesMatchingSearchTermMarkup = rendermyRoleRows(myRolesMatchingSearchTerm, false);
    myRolesNotMatchingSearchTermMarkup = rendermyRoleRows(myRolesNotMatchingSearchTerm, true);
  }

  return (
    <div className="my-roles-view-all text-size-mms ">
      <div className="ui sixteen column grid pdlm  pdrm">
        {getHeaderRowMarkup()}
        <div className="row flexible ui grid" id="my-roles-view-all-scroll-wrapper">
          {myRolesMatchingSearchTermMarkup}
          {myRolesNotMatchingSearchTermMarkup}
        </div>
      </div>
    </div>
  );
}
